// Kundenbewertungen (sections/mhsys-bewertungen.liquid, sections/mhsys-bewertungen-alle.liquid): Slider-Zaehler,
// "mehr lesen", Formular "Bewertung schreiben" und das Nachladen weiterer Bewertungen - alles ueber mhsys
// (App-Proxy /apps/kunde?bereich=bewertungen, Roadmap 3.3). Judge.me ist seit 22.09.2026 deinstalliert.
(function () {
  "use strict";

  // ---- Zaehler "2 / 5" am Slider: ein IntersectionObserver, kein Scroll-Handler ----
  function zaehlerEinrichten(wurzel) {
    var spur = wurzel.querySelector("[data-mhsys-bew-spur]");
    var zaehler = wurzel.querySelector("[data-mhsys-bew-zaehler]");
    if (!spur || !zaehler || !("IntersectionObserver" in window)) return;
    var karten = Array.prototype.slice.call(spur.querySelectorAll("[data-mhsys-bew-karte]"));
    var beobachter = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (e.isIntersecting) zaehler.textContent = (karten.indexOf(e.target) + 1) + " / " + karten.length;
      });
    }, { root: spur, threshold: 0.6 });
    karten.forEach(function (k) { beobachter.observe(k); });
    // Rueckfall, falls der Observer nicht meldet (z.B. Safari ohne Bildaufbau im Hintergrund): nach
    // dem Scrollen aus der Position rechnen. scrollend gibt es nicht ueberall - dann nur der Observer.
    spur.addEventListener("scrollend", function () {
      var breite = karten[0] ? karten[0].getBoundingClientRect().width : 0;
      if (!breite) return;
      var i = Math.min(karten.length - 1, Math.round(spur.scrollLeft / (breite + 12)));
      zaehler.textContent = (i + 1) + " / " + karten.length;
    });
  }

  // ---- "mehr lesen" bei langen Bewertungen ----
  // Der Text ist per CSS auf vier Zeilen gekuerzt (gespeichert ist er vollstaendig, geprueft 18.09.2026).
  // Der Knopf erscheint nur, wo wirklich etwas abgeschnitten ist.
  function mehrLesenEinrichten(wurzel) {
    wurzel.querySelectorAll("[data-mhsys-bew-text]").forEach(function (text) {
      var knopf = text.parentNode.querySelector("[data-mhsys-bew-mehr]");
      if (!knopf) return;
      if (text.scrollHeight > text.clientHeight + 2) knopf.hidden = false;
      knopf.addEventListener("click", function () {
        var offen = text.classList.toggle("is-offen");
        knopf.textContent = offen ? "weniger" : "mehr lesen";
        knopf.setAttribute("aria-expanded", offen ? "true" : "false");
      });
    });
  }

  // ---- Overlay "Bewertung schreiben" ----
  // Die Bewertung geht an mhsys: POST /apps/kunde?bereich=bewertungen
  // als JSON (mhsystem extern/kundeninhalte/bewertungen/, Paket C). Die Antwort ist lesbar: {ok, frei} oder
  // {ok:false, fehler:<code>} - der Code waehlt den Hinweis (FEHLER_TEXTE), Kunden sehen keine Technik.
  // Den Zeitstempel (_stempel, beim Oeffnen geholt, Roadmap 7.59) und das Honigtopffeld "website" prueft der Endpunkt.
  var PROXY = "/apps/kunde?bereich=bewertungen";
  // Mit Zeitlimit (layout/theme.liquid, Roadmap 7.44): antwortet mhsys nicht, kommt der Hinweis statt ewigem Laden
  function holen(url, init) { return window.mhsysNetz ? window.mhsysNetz.holen(url, init) : fetch(url, init); }
  var FEHLER_TEXTE = {
    doppelt: "Du hast diesen Artikel schon bewertet – vielen Dank dafür!",
    grenze: "Gerade kommen sehr viele Bewertungen an. Bitte versuch es in ein paar Minuten noch einmal.",
    schnell: "Bitte nimm dir noch einen Moment und schick sie dann noch einmal ab.",
    email: "Bitte gib eine gültige E-Mail-Adresse an.",
    text: "Bitte schreib ein paar Worte zu deiner Bewertung.",
    name: "Bitte gib deinen Namen an (ohne E-Mail-Adresse).",
    sterne: "Bitte wähl zuerst die Sterne aus."
  };

  function mhsysSenden(form) {
    var d = new FormData(form);
    var feld = function (k) { return (d.get(k) || "").toString().trim(); };
    var daten = {
      prod_id: form.dataset.produkt,
      sterne: feld("rating"),
      text: feld("body"),
      titel: feld("title"),
      name: feld("name"),
      email: feld("email"),
      website: (d.get("website") || "").toString()
    };
    var stempeln = window.mhsysStempel ? window.mhsysStempel.mit(daten) : Promise.resolve(daten);
    return stempeln.then(function (rumpf) {
      return holen(PROXY, {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(rumpf)
      });
    }).then(function (antwort) {
      return antwort.json().catch(function () { return { ok: false, fehler: "antwort" }; }).then(function (j) {
        if (!antwort.ok || !j || !j.ok) {
          var fehler = new Error((j && j.fehler) || "http");
          fehler.code = (j && j.fehler) || "";
          throw fehler;
        }
        return j;
      });
    });
  }

  function formularPruefen(form) {
    var d = new FormData(form);
    if (!d.get("rating")) return "Bitte wähl zuerst die Sterne aus.";
    if (!(d.get("body") || "").toString().trim()) return "Bitte schreib ein paar Worte zu deiner Bewertung.";
    if (!(d.get("name") || "").toString().trim()) return "Bitte gib deinen Namen an.";
    var mail = form.querySelector('[name="email"]');
    if (!mail.value.trim() || !mail.checkValidity()) return "Bitte gib eine gültige E-Mail-Adresse an.";
    return "";
  }

  function dialogEinrichten(wurzel) {
    var dialog = wurzel.querySelector("[data-mhsys-bew-dialog]");
    if (!dialog || typeof dialog.showModal !== "function") return null;
    var form = dialog.querySelector("[data-mhsys-bew-form]");
    var danke = dialog.querySelector("[data-mhsys-bew-danke]");
    var fehler = dialog.querySelector("[data-mhsys-bew-fehler]");
    var senden = dialog.querySelector("[data-mhsys-bew-senden]");

    function oeffnen() {
      form.hidden = false;
      danke.hidden = true;
      fehler.hidden = true;
      if (window.mhsysStempel) window.mhsysStempel.vor();
      dialog.showModal();
      var erster = form.querySelector('[name="rating"]:checked') || form.querySelector('[name="rating"]');
      if (erster) erster.focus();
    }

    dialog.addEventListener("click", function (e) {
      if (e.target.closest("[data-mhsys-bew-zu]") || e.target === dialog) dialog.close();
    });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var meldung = formularPruefen(form);
      if (meldung) {
        fehler.textContent = meldung;
        fehler.hidden = false;
        return;
      }
      fehler.hidden = true;
      senden.disabled = true;
      mhsysSenden(form)
        .then(function (antwort) {
          var dankeText = danke.querySelector("[data-mhsys-bew-danke-text]");
          if (dankeText && antwort && antwort.frei) {
            dankeText.textContent = "Danke für deine Bewertung! Sie erscheint in Kürze hier.";
          }
          form.reset();
          form.hidden = true;
          danke.hidden = false;
          var knopf = danke.querySelector("[data-mhsys-bew-zu]");
          if (knopf) knopf.focus();
        })
        .catch(function (f) {
          fehler.textContent = (f && FEHLER_TEXTE[f.code]) || "Das hat gerade nicht geklappt. Bitte versuch es gleich noch einmal.";
          fehler.hidden = false;
        })
        .finally(function () {
          senden.disabled = false;
        });
    });

    wurzel.addEventListener("click", function (e) {
      if (e.target.closest("[data-mhsys-bew-oeffnen]")) oeffnen();
    });
    return oeffnen;
  }

  // ---- "Alle X Bewertungen" aus mhsys ----
  // Holt die Seiten ueber GET /apps/kunde?bereich=bewertungen&produkt=&seite= (je 20, nur freigegebene, ohne
  // E-Mail - dieselben Schluessel wie custom.bewertungen) und zeigt sie als Liste statt des Sliders. Alle
  // Texte gehen ueber textContent, nie innerHTML - sie kommen von Kunden.
  function datumText(d) {
    var t = (d || "").split("-");
    return t.length === 3 ? t[2] + "." + t[1] + "." + t[0] : "";
  }

  function karteBauen(b) {
    var el = function (tag, klasse, text) {
      var e = document.createElement(tag);
      if (klasse) e.className = klasse;
      if (text !== undefined) e.textContent = text;
      return e;
    };
    var li = el("li", "mhsys-bewertung");
    var kopf = el("div", "mhsys-bewertung__kopf");
    var sterne = el("span", "mhsys-sterne");
    sterne.setAttribute("aria-hidden", "true");
    sterne.style.setProperty("--mhsys-sterne", Math.max(0, Math.min(100, (b.s || 0) * 20)) + "%");
    kopf.appendChild(sterne);
    kopf.appendChild(el("span", "mhsys-vh", (b.s || 0) + " von 5 Sternen"));
    if (b.n) kopf.appendChild(el("span", "mhsys-bewertung__name", b.n));
    if (b.v === 1) kopf.appendChild(el("span", "mhsys-bewertung__verifiziert", "Verifizierter Kauf"));
    kopf.appendChild(el("span", "mhsys-bewertung__datum", datumText(b.d)));
    li.appendChild(kopf);
    // Shopbewertung von Trusted Shops (mhsys Roadmap 3.95): q = Herkunft, steht an jeder dieser Karten
    if (b.q) li.appendChild(el("p", "mhsys-bewertung__quelle", b.q));
    // Shop-Liste (sections/mhsys-bewertungen-alle.liquid): jede Bewertung traegt ihr Produkt (p/pt/ph)
    if (b.pt && b.ph && /^[a-z0-9][a-z0-9-]*$/i.test(b.ph)) {
      var produkt = el("a", "mhsys-bewertung__produkt", b.pt);
      produkt.href = ((window.mhsysShop && window.mhsysShop.wurzelUrl) || "/").replace(/\/?$/, "/") + "products/" + b.ph;
      li.appendChild(produkt);
    }
    if (b.t) li.appendChild(el("p", "mhsys-bewertung__titel", b.t));
    if (b.b) li.appendChild(el("p", "mhsys-bewertung__text is-offen", b.b));
    if (b.f && b.f.length) {
      var fotos = el("div", "mhsys-bewertung__fotos");
      b.f.forEach(function (u) {
        if (typeof u !== "string" || u.indexOf("https://") !== 0) return;
        var a = el("a");
        a.href = u; a.target = "_blank"; a.rel = "noopener";
        var img = el("img");
        img.src = u + (u.indexOf("?") >= 0 ? "&" : "?") + "width=240";
        img.alt = "Kundenfoto"; img.width = 72; img.height = 72; img.loading = "lazy";
        a.appendChild(img);
        fotos.appendChild(a);
      });
      if (fotos.childNodes.length) li.appendChild(fotos);
    }
    if (b.a) {
      var antwort = el("div", "mhsys-bewertung__antwort");
      antwort.appendChild(el("p", "mhsys-bewertung__antwort-von", "Antwort von meinherzschlag.de"));
      antwort.appendChild(el("p", "", b.a));
      li.appendChild(antwort);
    }
    return li;
  }

  function alleMhsysEinrichten(wurzel) {
    var knopf = wurzel.querySelector("[data-mhsys-bew-alle]");
    var liste = wurzel.querySelector("[data-mhsys-bew-alle-liste]");
    var weiter = wurzel.querySelector("[data-mhsys-bew-weiter]");
    var meldung = wurzel.querySelector("[data-mhsys-bew-alle-meldung]");
    if (!knopf || !liste || !weiter) return;
    var seite = 0;
    var laedt = false;

    function laden() {
      if (laedt) return;
      laedt = true;
      wurzel.classList.add("mhsys-bewertungen--laedt");
      if (meldung) meldung.hidden = true;
      var url = PROXY + "&produkt=" + encodeURIComponent(knopf.dataset.produkt) + "&seite=" + (seite + 1);
      holen(url, { credentials: "same-origin" })
        .then(function (a) { if (!a.ok) throw new Error("HTTP " + a.status); return a.json(); })
        .then(function (j) {
          if (!j || !j.ok) throw new Error("Antwort");
          (j.r || []).forEach(function (b) { liste.appendChild(karteBauen(b)); });
          seite = j.seite || seite + 1;
          liste.hidden = false;
          var slider = wurzel.querySelector(".mhsys-bewertungen__slider");
          if (slider) slider.hidden = true;
          knopf.hidden = true;
          weiter.hidden = !(j.seiten > seite);
        })
        .catch(function (f) {
          if (meldung) {
            meldung.textContent = "Die Bewertungen konnten gerade nicht geladen werden. Bitte versuch es gleich noch einmal.";
            meldung.hidden = false;
          }
          if (window.console) console.warn("Bewertungen: Seite nicht geladen (" + f.message + ")");
        })
        .finally(function () {
          laedt = false;
          wurzel.classList.remove("mhsys-bewertungen--laedt");
        });
    }

    knopf.addEventListener("click", laden);
    weiter.addEventListener("click", laden);
  }

  // Erkennungsmerkmal einer Karte - gleich fuer Liquid- und Skript-Karten (nur Text, keine Klassen/Struktur)
  function karteSchluessel(li) {
    var t = function (s) { var e = li.querySelector(s); return e ? e.textContent.replace(/\s+/g, " ").trim() : ""; };
    return [t(".mhsys-bewertung__name"), t(".mhsys-bewertung__datum"), t(".mhsys-bewertung__produkt"),
      t(".mhsys-bewertung__titel"), t(".mhsys-bewertung__text")].join("|");
  }

  // ---- Seite "Glueckliche Kunden": alle Shop-Bewertungen (sections/mhsys-bewertungen-alle.liquid) ----
  // Die ersten 20 stehen fertig im HTML (data-seite="1"); weitere je 20 per Knopf ueber den Proxy, shop-weit
  // (produkt=alle). Fehlt die erste Seite im HTML (data-seite="0"), kommt sie gleich beim Laden. Die Brezn
  // (window.mhsysLadeAnzeige, assets/mhsys-popup.js) zeigt ein langsames Nachladen an.
  function shopListeEinrichten() {
    document.querySelectorAll("[data-mhsys-bew-shop]").forEach(function (wurzel) {
      if (wurzel.dataset.mhsysBereit) return;
      wurzel.dataset.mhsysBereit = "1";
      var liste = wurzel.querySelector("[data-mhsys-bew-shop-liste]");
      var weiter = wurzel.querySelector("[data-mhsys-bew-shop-weiter]");
      var meldung = wurzel.querySelector("[data-mhsys-bew-shop-meldung]");
      if (!liste) return;
      var seite = parseInt(liste.dataset.seite || "0", 10) || 0;
      var laedt = false;

      function laden() {
        if (laedt) return;
        laedt = true;
        if (meldung) meldung.hidden = true;
        if (weiter) weiter.disabled = true;
        var anzeige = null;
        if (typeof window.mhsysLadeAnzeige === "function") {
          anzeige = document.createElement("li");
          anzeige.className = "mhsys-bew-shop__laden";
          anzeige.appendChild(window.mhsysLadeAnzeige());
          liste.appendChild(anzeige);
        }
        holen(PROXY + "&produkt=alle&seite=" + (seite + 1), { credentials: "same-origin" })
          .then(function (a) { if (!a.ok) throw new Error("HTTP " + a.status); return a.json(); })
          .then(function (j) {
            if (!j || !j.ok) throw new Error("Antwort");
            if (anzeige) anzeige.remove();
            // Die ersten 20 kommen aus dem Metafeld (Stand des letzten Sendens), die weiteren frisch vom Proxy.
            // Kamen dazwischen neue Bewertungen dazu (Import, Freigabe), rutschen die Proxy-Seiten nach hinten
            // und die letzten Karten stuenden doppelt da - schon gezeigte also ueberspringen.
            var gezeigt = {};
            liste.querySelectorAll("li.mhsys-bewertung").forEach(function (li) { gezeigt[karteSchluessel(li)] = 1; });
            (j.r || []).forEach(function (b) {
              var karte = karteBauen(b);
              if (!gezeigt[karteSchluessel(karte)]) liste.appendChild(karte);
            });
            seite = j.seite || seite + 1;
            if (weiter) weiter.hidden = !(j.seiten > seite);
          })
          .catch(function (f) {
            if (anzeige) anzeige.remove();
            if (meldung) {
              meldung.textContent = "Die Bewertungen konnten gerade nicht geladen werden. Bitte versuch es gleich noch einmal.";
              meldung.hidden = false;
            }
            if (window.console) console.warn("Bewertungen: Shop-Liste nicht geladen (" + f.message + ")");
          })
          .finally(function () {
            laedt = false;
            if (weiter) weiter.disabled = false;
          });
      }

      if (weiter) weiter.addEventListener("click", laden);
      if (seite === 0) laden();
    });
  }

  function alleEinrichten() {
    shopListeEinrichten();
    document.querySelectorAll("[data-mhsys-bewertungen]").forEach(function (wurzel) {
      if (!wurzel.dataset.mhsysBewNeu) {
        wurzel.dataset.mhsysBewNeu = "1";
        zaehlerEinrichten(wurzel);
        mehrLesenEinrichten(wurzel);
        alleMhsysEinrichten(wurzel);
        var oeffnen = dialogEinrichten(wurzel);
        // Link "Bewertung schreiben" von anderer Stelle (z.B. #bewertung-schreiben) oeffnet das Overlay
        if (oeffnen && window.location.hash === "#bewertung-schreiben") oeffnen();
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", alleEinrichten);
  } else {
    alleEinrichten();
  }
  document.addEventListener("shopify:section:load", alleEinrichten);
})();
